import {
    BalanceChanges,
    fetchAndDeserializeLegacyTransactionsWithSetup,
    fetchAndDeserializeVersionedTransaction,
    fetchAndDeserializeVersionedTransactionWithBalanceChanges,
    TransactionsWithDataGenerateReturn
} from "@bridgesplit/utils";

import {
    AbfTransactionHeaders,
    TXN_CREDITBOOK_REPAY,
    TXN_CREDITBOOK_CREATE,
    SetupLoanArgs,
    RepayLoanTxnParams,
    TXN_CREDITBOOK_DEPOSIT_COLLATERAL,
    DepositCollateralParams,
    TXN_CREDITBOOK_WITHDRAW_COLLATERAL,
    WithdrawCollateralTxnParams,
    TXN_CREDITBOOK_REFINANCE,
    RefinanceLoanTxnParams,
    SwapCollateralTxnParams,
    TXN_CREDITBOOK_SWAP_COLLATERAL,
    TXN_CREDITBOOK_CLOSE_LOAN,
    CloseLoanTxnParams
} from "../types";
import { createMarketsInstance } from "./auth";

export async function getSetupLoanTransactions(authentication: AbfTransactionHeaders, args: SetupLoanArgs) {
    return await fetchAndDeserializeLegacyTransactionsWithSetup(
        createMarketsInstance(authentication),
        TXN_CREDITBOOK_CREATE,
        args
    );
}

export async function getRepayLoanTransactionAndBalanceChanges(
    authentication: AbfTransactionHeaders,
    args: RepayLoanTxnParams
): Promise<TransactionsWithDataGenerateReturn<{ balanceChanges: BalanceChanges }>> {
    const { transaction, balanceChanges } = await fetchAndDeserializeVersionedTransactionWithBalanceChanges(
        createMarketsInstance(authentication),
        TXN_CREDITBOOK_REPAY,
        args
    );

    return { transactions: [transaction], balanceChanges };
}

export async function getDepositCollateralTransaction(
    authentication: AbfTransactionHeaders,
    args: DepositCollateralParams
) {
    return [
        await fetchAndDeserializeVersionedTransaction(
            createMarketsInstance(authentication),
            TXN_CREDITBOOK_DEPOSIT_COLLATERAL,
            args
        )
    ];
}

export async function getSwapCollateralTransaction(
    authentication: AbfTransactionHeaders,
    args: SwapCollateralTxnParams
) {
    return [
        await fetchAndDeserializeVersionedTransaction(
            createMarketsInstance(authentication),
            TXN_CREDITBOOK_SWAP_COLLATERAL,
            args
        )
    ];
}

export async function getWithdrawCollateralTransaction(
    authentication: AbfTransactionHeaders,
    args: WithdrawCollateralTxnParams
) {
    return [
        await fetchAndDeserializeVersionedTransaction(
            createMarketsInstance(authentication),
            TXN_CREDITBOOK_WITHDRAW_COLLATERAL,
            args
        )
    ];
}

export async function getRefinanceLoanTransaction(authentication: AbfTransactionHeaders, args: RefinanceLoanTxnParams) {
    return [
        await fetchAndDeserializeVersionedTransaction(
            createMarketsInstance(authentication),
            TXN_CREDITBOOK_REFINANCE,
            args
        )
    ];
}

export async function getCloseLoanTransaction(authentication: AbfTransactionHeaders, args: CloseLoanTxnParams) {
    return [
        await fetchAndDeserializeVersionedTransaction(
            createMarketsInstance(authentication),
            TXN_CREDITBOOK_CLOSE_LOAN,
            args
        )
    ];
}
